import React from 'react';
import PropTypes from 'prop-types';
import { Table, Descriptions, Empty } from 'antd';
import startCase from 'lodash-es/startCase';
import { transformStripePrice, transformMinToHr } from '@services/transform';

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: 'Price',
    dataIndex: 'price',
    key: 'price'
  },
  {
    title: 'Time',
    dataIndex: 'time',
    key: 'time'
  }
];

function PriceTable(props) {
  let dataSource = [];
  const { data } = props;

  if (!data) {
    return null;
  }

  if (data.price) {
    dataSource = data.price.map((price, index) => ({
      key: index,
      name: `${index} bedrooms`,
      price: `$${transformStripePrice(price)}`,
      time: transformMinToHr(data.time[index])
    }));
  } else {
    dataSource = Object.keys(data).map(addonKey => ({
      key: addonKey,
      name: startCase(addonKey),
      price: `$${transformStripePrice(data[addonKey].price)}`,
      time: transformMinToHr(data[addonKey].time)
    }));
  }

  return <Table dataSource={dataSource} columns={columns} pagination={false} />;
}

PriceTable.propTypes = {
  data: PropTypes.object
};

function PricingSummary(props) {
  const { pricingData, disabled } = props;

  const { data } = pricingData || {};

  if (!data) {
    return <Empty />;
  }

  const {
    addons: propertyAddons,
    specialServices: propertySpecialServices,
    ...mainServices
  } = data || {};

  return (
    <div style={{ position: 'relative' }}>
      <Descriptions bordered column={2}>
        {Object.keys(mainServices).map(serviceType => (
          <Descriptions.Item key={serviceType} label={startCase(serviceType)}>
            <PriceTable data={mainServices[serviceType]} />
          </Descriptions.Item>
        ))}

        <Descriptions.Item label="Additonal Services">
          <PriceTable data={propertyAddons} />
        </Descriptions.Item>
        <Descriptions.Item label="Special Services">
          {Object.keys(propertySpecialServices || {}).map(serviceKey => (
            <PriceTable
              key={serviceKey}
              data={propertySpecialServices[serviceKey]}
            />
          ))}
        </Descriptions.Item>
      </Descriptions>
      {disabled && (
        <div
          style={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            backdropFilter: 'blur(1px) saturate(150%)'
          }}
        ></div>
      )}
    </div>
  );
}

PricingSummary.propTypes = {
  pricingData: PropTypes.object,
  disabled: PropTypes.bool
};

export default PricingSummary;
